import { NamedElementCaptureOptions } from '@fullstory/redux';

export enum NamedElementModalSource {
  settings,
  relatedSettings,
  inspect,
  search,
  journeys,
  metrics,
  heatmaps,
  retention,
  conversions,
  home,
}

export enum NamedElementModalVariant {
  new,
  edit,
  view,
}

export interface CaptureOptionsUpdate {
  prev: NamedElementCaptureOptions;
  next: NamedElementCaptureOptions;
}
